/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CopyAction from './CopyAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy/PaymentMethod/BankAccountPayment/TransactionId/Content"
  
}) {
let constantData = '[ Transaction ID:'
let paymentTransactionIdValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'transaction_id',
})
let constantData1 = ']'
let aggregateData = fromAggregate.join(constantData, paymentTransactionIdValueData, constantData1)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="'[ Transaction ID:'"
 data="payment.transaction_id"
 data="']'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<CopyAction
  viewPath={`${viewPath}/CopyAction`}
/>
{children}
</React.Fragment>)
}